// ساختنِ کانالِ Realtime، بدونِ برخورد با کانالی که از قبل هست.
//
// ═══ باگی که این فایل برایش نوشته شد ═══
//
// `supabase.channel(name)` کانالِ **موجود** با همان نام را برمی‌گرداند، نه یک
// کانالِ تازه. و اگر آن کانال از قبل `subscribe()` شده باشد، افزودنِ شنونده
// رویش خطا می‌دهد:
//
//     cannot add `postgres_changes` callbacks for realtime:notif-<uid>
//     after `subscribe()`
//
// این خطا وسطِ **رندر** پرتاب می‌شد و چون هیچ ErrorBoundary ای نبود، کلِ
// درخت را می‌برد: صفحه‌ی سفیدِ قفل که فقط با بستنِ دستیِ اپ باز می‌شد. با
// پشته‌ی کامپوننت‌ها معلوم شد `TabsLayout` است.
//
// چرا آن‌جا: نامِ کانال ثابت است (یکی به‌ازای هر کاربر)، و
// `router.replace('/(tabs)')` آن لایه را دوباره سوار می‌کند. React اشتراکِ
// تازه را **پیش از** پاک‌سازیِ قبلی می‌سازد، پس یک لحظه هر دو زنده‌اند و
// دومی روی کانالِ مشترک‌شده‌ی اولی می‌نشیند.
//
// ═══ راهش ═══
//
// پیش از ساختن، هر کانالی با همین نام که جا مانده برداشته می‌شود. نامِ ثابت
// عمدی است (یک کانال به‌ازای هر کاربر/گفتگو، نه یکی به‌ازای هر بار سوار
// شدن)، پس راهِ درست پاک کردنِ کهنه است، نه یکتا کردنِ نام — که فقط نشتِ
// کانال می‌سازد.

/** حداقلِ چیزی که از کلاینتِ Supabase لازم داریم — تا این فایل تست‌پذیر بماند. */
export interface ChannelHost<C> {
  channel(name: string): C;
  getChannels(): C[];
  removeChannel(ch: C): unknown;
}

/**
 * نامی که کلاینت روی کانال می‌گذارد پیشوندِ `realtime:` دارد، ولی چیزی که
 * ما پاس می‌دهیم ندارد. هر دو شکل پذیرفته می‌شود تا این تابع به جزئیاتِ
 * درونیِ کتابخانه بند نباشد.
 */
const sameTopic = (topic: string, name: string): boolean =>
  topic === name || topic === `realtime:${name}`;

/**
 * یک کانالِ تمیز با این نام.
 *
 * هر کانالِ جامانده‌ی هم‌نام اول برداشته می‌شود، پس آنچه برمی‌گردد هیچ‌وقت
 * کانالی نیست که از قبل `subscribe()` شده باشد.
 */
export function freshChannel<C extends { topic: string }>(
  host: ChannelHost<C>, name: string,
): C {
  for (const c of host.getChannels()) {
    if (sameTopic(c.topic, name)) host.removeChannel(c);
  }
  return host.channel(name);
}
